import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const LearnMoreaboutme = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <section className="w-full py-4 sm:py-6 lg:py-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1
            className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-center tracking-wide capitalize dmsans"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            "Learn More About My Work"
          </h1>

          <p
            className="mt-4 sm:mt-6 lg:mt-8 text-sm sm:text-base md:text-lg lg:text-xl text-center text-[#55586F] tracking-wide leading-relaxed heebo max-w-3xl mx-auto"
            data-aos="fade-in"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            Sailesh Dani is a highly professional consultant with expertise in
            diverse fields, making significant contributions to the development
            of innovative projects in Odisha and beyond.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LearnMoreaboutme;
